import { takeEvery } from 'redux-saga/effects';
import { SettingsActionType } from '@engage/settings/redux';
import updateDisplaySettings from './updateDisplaySettings';

const settingsSaga = function* () {
  yield takeEvery(SettingsActionType.UpdateDisplayPreferences, updateDisplaySettings);
};

export default settingsSaga;
